import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

const Tabs = (props) => {
    const {
        setPriTitle,
        setSubTitle,
        setTextTab,
        tabs,
        setIndex,
        index,
        gtag4
    } = props;

    //click on tab menu
    const handelClickTab = (item, i) =>{
        setSubTitle(item.subTitle)
        setPriTitle(item.title)
        setIndex(i)
        setTextTab(item.textTab)
        gtag4({event: 'CarouselPackagesSale_CategoryClick', category: item.textTab, section: 'CarouselPackagesSale'}) //Google analytic
    };

    return (
        <>
            {tabs?.length > 1 &&
                <div className='container-tabs'>
                        <Swiper
                            className={`swiper-tabs swiper-tabs-mobile ${tabs.length > 3 ? 'tree-items' : ''}`}
                            navigation={false}
                            slidesPerView={'auto'}
                            enabled={tabs.length >= 2} //Will trigger a swiper only if the length of the array is greater than 2
                            breakpoints={{
                                //when window width is >= 100px
                                100: {
                                    allowTouchMove: true, //swiper at
                                    spaceBetween: 6
                                },
                                // when window width is >= 835px
                                835: {
                                    allowTouchMove: false //no swiper at desktop
                                }
                            }}
                        >
                            {tabs.map((item,i)=>
                                <SwiperSlide
                                    key={i}
                                    className={` swiper-item ${ i == index  ? 'active' : null}`}
                                    onClick={()=>handelClickTab(item, i)}
                                >
                                <div className='wrapper-titles'>
                                    {i == index && item.icon.src && <Image className='iconTab' src={item.icon.src} alt ={item.icon.alt} />}
                                    {item.textTab && <div className='textTab'>{item.textTab}</div>}
                                </div>
                                </SwiperSlide>
                            )}
                        </Swiper>
                </div>
            }
        </>
    );
};

export default Tabs;
